export default __webpack_public_path__ + "static/media/arrow-back-big.2ee45c3c.svg";